export default {"src":"/_next/static/media/safemoon.748cd7ec.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};